'use client'
import React, { createContext, useMemo } from 'react'

import { Profession } from '~/generated/graphql'

export type RemoteConfigContextType = {
  professions: Profession[]
}

export const RemoteConfigContext = createContext<RemoteConfigContextType>({
  professions: [],
})

export function RemoteConfigProvider({ children, professions }: React.PropsWithChildren<RemoteConfigContextType>) {
  const sortedProfessions = useMemo(() => [...professions].sort((a, b) => a.name.localeCompare(b.name)), [professions])

  return (
    <RemoteConfigContext.Provider value={{ professions: sortedProfessions }}>{children}</RemoteConfigContext.Provider>
  )
}

export function RemoteConfigProviderStorybook({ children }: React.PropsWithChildren) {
  const professions = Array.from({ length: 10 }, (_, index) => ({
    name: `profession${index}`,
    id: index.toString(),
  }))

  return <RemoteConfigContext.Provider value={{ professions }}>{children}</RemoteConfigContext.Provider>
}
